import { Fragment } from 'react';

import Select from 'components/Select';
import Button from 'components/Button';
import HasError from 'hocs/HasError';
import { InputHasLabelError } from 'components/Input/InputVariants';

import { COUNTRIES } from '../constants';

let SelectHasError;

const BusinessData = ({ values, errors, onChange, toggle, submitting }) => {
  SelectHasError = HasError(Select);
  return (
    <Fragment>
      <div className="section__header-wrap _mb-39">
        <h2 className="title section__title _mb-21">About your business</h2>
        <p className="text section__text">
          Tell us a little about your business.
        </p>
      </div>
      <div className="form__row _mb-17">
        <InputHasLabelError
          name="businessName"
          placeholder="Example Inc."
          error={errors.businessName}
          value={values.businessName}
          onChange={onChange}
          labelClassName="_mb-7"
          label="Business Name"
        />
      </div>
      <div className="form__row _mb-17">
        <InputHasLabelError
          name="url"
          placeholder="example.com"
          error={errors.url}
          value={values.url}
          onChange={onChange}
          labelClassName="_mb-7"
          label="Your Website"
        />
      </div>
      <div className="form__row _mb-24">
        <div className="Select__label _mb-7">Country</div>
        <SelectHasError
          options={COUNTRIES}
          searchable
          value={values.country}
          name="country"
          className={cx({ error: errors.country })}
          placeholder="Select a Country"
          error={errors.country}
          onChange={onChange}
        />
      </div>
      <Button className="btn_wide _mb-50" submitting={submitting}>
        Finish
      </Button>
      <div className="form__switcher-wrap">
        <span className="btn_switcher" onClick={toggle} />
        <span className="btn_switcher btn_switcher_last btn_switcher_active btn_switcher_disabled" />
      </div>
    </Fragment>
  );
};

export default BusinessData;
